export enum ModelState {
    "Create" = 10,
    "Train" = 20,
    "Online" = 30,
    "Error" = 100
}